"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonDataReducer = commonDataReducer;
exports.serviceInitialState = exports.default = exports.commonServiceDataReducer = void 0;
var _const = require("./const");
var _actions = _interopRequireWildcard(require("./actions"));
var apiActions = _actions;
var _simpleDataReducer = require("../../../common/utils/simpleDataReducer");
var _seamlessImmutable = _interopRequireDefault(require("seamless-immutable"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getCommonServiceData = (0, _simpleDataReducer.createReducer)(apiActions.GET_COMMON_SERVICE_DATA_API);
const updateLocaleData = (0, _simpleDataReducer.createReducer)(apiActions.UPDATE_LOCALE_DATA_API);
const captureAreaLead = (0, _simpleDataReducer.createReducer)(apiActions.CAPTURE_AREA_LEAD_API);
const serviceInitialState = exports.serviceInitialState = (0, _seamlessImmutable.default)({
  notifications: [],
  loyaltyPoints: [],
  healthProfile: [],
  address: [],
  savedCards: [],
  wishlist: [],
  insurance: [],
  myPackages: []
});
function commonDataReducer(state, action) {
  const finalState = state !== null && state !== void 0 ? state : serviceInitialState;
  switch (action.type) {
    case _actions.SET_COMMON_SERVICE_DATA:
      return {
        ...finalState,
        ...action.data
      };
    default:
      return finalState;
  }
}
var _default = exports.default = {
  [_const.GET_COMMON_SERVICE_DATA]: getCommonServiceData,
  [_const.UPDATE_LOCALE_DATA]: updateLocaleData,
  [_const.CAPTURE_AREA_LEAD]: captureAreaLead
};
const commonServiceDataReducer = exports.commonServiceDataReducer = {
  [_const.COMMON_SERVICE_DATA]: commonDataReducer
};